import currencySymbols from "../utils/currencySymbols";

var Currency = function Currency(_ref) {
  var code = _ref.code,
      value = _ref.value;

  var _ref2 = currencySymbols[code] || {},
      _ref2$symbol = _ref2.symbol,
      symbol = _ref2$symbol === void 0 ? code : _ref2$symbol,
      _ref2$right = _ref2.right,
      right = _ref2$right === void 0 ? false : _ref2$right;

  var number = Number(value);
  var isNegative = number < 0;
  var absNumber = Math.abs(number);
  return "".concat(isNegative ? '-' : '').concat(!right ? symbol : '').concat(value !== undefined && value !== null ? absNumber : '').concat(right ? symbol : '');
};

export default Currency;